import { TextField } from "@mui/material";
import React from "react";

export const DebouncedInput = ({
  value: initialValue,
  onChange,
  placeholderText,
  debounce = 100,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholderText: string;
  debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange">) => {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value, onChange, debounce]);

  return (
    <TextField
      fullWidth
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder={placeholderText}
      variant="outlined"
      size="small"
    />
  );
};
